function registerMobileMenuSubMenuToggle() {
    const navigationItems = document.querySelectorAll('.site-header .wp-block-navigation-item.has-child');

    navigationItems.forEach(function (item) {
        const submenu = item.querySelector('.wp-block-navigation-submenu');
        if (submenu && window.innerWidth < 1200) {
            item.classList.add('is-open');
            submenu.classList.add('is-open');
        }
    });

    navigationItems.forEach(function (item) {
        const link = item.querySelector('a');
        const submenu = item.querySelector('.wp-block-navigation-submenu');
        if (link && submenu) {
            link.addEventListener('click', function (event) {
                const responsiveContainer = document.querySelector(
                    '.wp-block-navigation__responsive-container.is-menu-open'
                );
                if (responsiveContainer && window.innerWidth < 1200) {
                    event.preventDefault();
                    item.classList.toggle('is-open');
                    submenu.classList.toggle('is-open');
                }
            });
        }
    });
}

const { register } = window.sitchco;
register(registerMobileMenuSubMenuToggle);
